<template>
  <div class="mb-2">
    <p class="mb-1">
      バージョン <code>{{ masterVersion }}</code>
      <span v-if="hasEnoughData">のマスタ取り込みを実行します。</span>
      <span v-else
        >では <span class="text-danger">必要なファイルが設定されていません</span></span
      >
    </p>
    <div class="alert alert-primary-light p-2">
      <strong class="d-block small">取込対象ファイル:</strong>
      <span
        class="pr-1 pl-2 d-block small"
        v-for="(f, key) in fileNames"
      >
        {{ $core.$models.yhc_masters.columns[key].label }}: <code>{{ f }}</code>
      </span>
    </div>
    <div
      v-if="legacyTimeBandWarningCount > 0"
      class="alert alert-warning p-2 mt-2 small"
    >
      時間帯区分 1 または 2 が
      <strong>{{ legacyTimeBandWarningCount }}</strong>
      件残っています。2027-01-01 以降の版では 0 または 3
      を想定しています（変換せず取り込みました）。
      <span v-if="legacyTimeBandWarningZips.length">
        例:
        <code>{{ legacyTimeBandWarningZips.join(', ') }}</code>
      </span>
    </div>
    <div class="text-center">
      <button
        class="btn btn-success"
        :class="hasEnoughData ? '' : 'disabled'"
        @click.prevent="() => kickImport()"
      >
        取込実行
      </button>
    </div>
  </div>
</template>
<script lang="ts">
import { ModelYhcMasters } from '../../../fireModels/yhcDataTypes'
import { PropType } from 'vue'

const fileProps = [
  'zipcode_master_file',
  'hours_master_file',
  'minreqday_master_file',
  'prices_master_file',
]

/**
 * Model `yhc_masters` の フォーム内 beforeComponent として登録される
 *
 * ## 役割
 * - マスタデータのインポート kick するボタンを表示
 *   - 実行 kick 後, メッセージを表示
 * - TODO: 取込実行履歴を表示
 */
export default {
  name: 'KickMasterDataImportWithVersionButton',
  props: {
    record: {
      type: Object as PropType<ModelYhcMasters>,
      required: true,
    },
  },
  data() {
    return {
      legacyTimeBandWarningCount: 0,
      legacyTimeBandWarningZips: [] as string[],
    }
  },
  computed: {
    recordId() {
      return this.record.id
    },
    masterVersion() {
      return this.record.version
    },
    fileNames() {
      return fileProps.reduce((acc, prop) => {
        acc[prop] = this.record[prop]
        return acc
      }, {})
    },
    hasEnoughData() {
      return Object.values(this.fileNames).filter((d) => d).length === 4
    },
  },
  methods: {
    async kickImport() {
      if (!this.hasEnoughData) {
        return
      }
      if (
        (await $core.$toast.confirmDialog(
          'マスタデータ取込処理を実施します。よろしいですか？ (約30秒ほど処理時間を要します)',
        )) !== true
      ) {
        return
      }
      $core.$loading.start('マスタデータ取込処理を実施しています...', 'overlay')
      try {
        const res = await $core.$d.transport.post('/yhc/generateMasterDataWithVersion', {
          version: this.masterVersion,
        })
        console.log({ res })
        const meta = res?.data?.meta || res?.meta || {}
        this.legacyTimeBandWarningCount = meta.legacyTimeBandWarningCount || 0
        this.legacyTimeBandWarningZips = meta.legacyTimeBandWarningZips || []
        $core.$toast.success('マスタデータ取込処理を完了しました')
        if (this.legacyTimeBandWarningCount > 0) {
          $core.$toast.error(
            `警告: 時間帯区分 1 または 2 が ${this.legacyTimeBandWarningCount} 件残っています。変換せず取り込みました。`,
          )
        }
      } catch (e) {
        $core.$toast.error('マスタデータ取込処理に失敗しました')
      } finally {
        $core.$loading.finish()
      }
    },
  },
}
</script>
